import { render, staticRenderFns } from "./Market.vue?vue&type=template&id=2a0a01e4&scoped=true&"
import script from "./Market.vue?vue&type=script&lang=js&"
export * from "./Market.vue?vue&type=script&lang=js&"
import style0 from "./Market.vue?vue&type=style&index=0&id=2a0a01e4&prod&lang=css&"
import style1 from "./Market.vue?vue&type=style&index=1&id=2a0a01e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0a01e4",
  null
  
)

export default component.exports